import { Link } from "react-router-dom";

const WinnerLink = () => {
  return (
    <div className="flex justify-between items-center py-4">
      <Link to="/winner"
        className={`border-2 border-slate text-slate px-3 py-2 text-sm uppercase mx-auto font-bold inline-block`}
      >
        CHECK THE WINNER PAGE
      </Link>
    </div>
  )
}

export default WinnerLink;
